// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"ff0bad04","241":"0012ae87","670":"80e783da","758":"0db0b261","853":"fbbb4870","896":"75465100"}[chunkId] + ".chunk.css";
};